import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib/axios";
import { RequestPatientResponse } from "@/types";

async function createPatient(
  request: FormData
): Promise<RequestPatientResponse> {
  const response = await httpRequest.post<RequestPatientResponse>(
    "/patients",
    request,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
}

export function useCreatePatientMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createPatient,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["patients"] });
    },
  });
}

export type CreatePatientJustNameDTO = {
  name: string;
};

async function createPatientJustName(
  request: CreatePatientJustNameDTO
): Promise<RequestPatientResponse> {
  const response = await httpRequest.post<RequestPatientResponse>(
    "/patients",
    request
  );
  return response.data;
}

export function useCreatePatientJustNameMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createPatientJustName,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["patients"] });
    },
  });
}
